import React, { useEffect, useState } from 'react';
import { Modal, Button, Icon, Header, Toast, Message, Items } from 'react-frontier';
import { EventWorker, SetLoading } from '../SiteClasses';
import API from '../API';

interface SendConfirmationModalProps{
	open: boolean;
	onClose: () => void;
	dateId: number;
	workers?: EventWorker[];
	onSent?: () => void;
}

var SendConfirmationModal = (props: SendConfirmationModalProps)=>{
	var [selectedWorkers, setSelectedWorkers] = useState<number[]>([]);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);

	useEffect(()=>{
		if(!props.open) return;
		setModalPrompts(null);
		if(props.workers?.length === 1){
			setSelectedWorkers([props.workers[0].worker_id]);
		}else{
			setSelectedWorkers([]);
		}
	}, [props.open]);

	var submit = (setLoading: SetLoading)=>{
		var ids = props.workers?.length === 1 ? [props.workers[0].worker_id] : selectedWorkers;
		if(ids.length === 0) return setModalPrompts(['Selecciona al menos un trabajador.']);

		setLoading(true);
		setModalPrompts(null);
		API.sendEventWorkersSMS(props.dateId, ids).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('SMS enviados correctamente.');

			props.onSent?.();
			props.onClose();
		}).catch(()=>{
			setModalPrompts(['Hubo un error enviando los SMS (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	};

	if(props.workers?.length === 1){
		var w = props.workers[0];
		return (
			<Modal open={props.open} size='tiny' onClose={props.onClose}>
				<Modal.Header>Notificar</Modal.Header>
				<Modal.Content>
					<Header
						text={`¿Notificar a ${w.worker_name}?`}
						subtext='Se enviará un mensaje pidiendo confirmar su asistencia al evento.'
					/>
					{!w.phone && (
						<Message type='warning' text='Este trabajador no tiene número de teléfono registrado.' style={{ marginTop: 10 }} />
					)}
					{!!w.confirmed && (
						<Message type='warning' text='Este trabajador ya confirmó su asistencia.' style={{ marginTop: 10 }} />
					)}
					<Message type='error' list={modalPrompts} />
				</Modal.Content>
				<Modal.Actions>
					<Button text='Cerrar' basic onClick={props.onClose} />
					<Button
						text='Enviar'
						color='black'
						onClick={submit}
						disabled={!w.phone || !!w.confirmed}
					/>
				</Modal.Actions>
			</Modal>
		);
	}

	var workers = props.workers || [];

	return (
		<Modal open={props.open} size='tiny' onClose={props.onClose}>
			<Modal.Header>Notificar trabajadores</Modal.Header>
			{workers.length === 0 ? (
				<>
					<Modal.Content>
						<Header text='Sin trabajadores pendientes' subtext='Todos los trabajadores ya confirmaron o no tienen teléfono registrado.' />
					</Modal.Content>
					<Modal.Actions>
						<Button text='Cerrar' basic onClick={props.onClose} />
					</Modal.Actions>
				</>
			) : (
				<>
					<Modal.Content>
						<div style={{ textAlign: 'center', padding: '5px 0 10px' }}>
							<Button
								text='Seleccionar todos'
								color='black'
								size='tiny'
								onClick={()=>{
									if(selectedWorkers.length === workers.length){
										setSelectedWorkers([]);
									}else{
										setSelectedWorkers(workers.map(w => w.worker_id));
									}
								}}
							/>
						</div>
						<Items
							style={{ overflow: 'auto', maxHeight: 300, overflowY: 'scroll' }}
							toggle
							selectable
							data={workers}
							selected={selectedWorkers}
							onToggle={setSelectedWorkers}
							valueExtractor={(w: EventWorker) => w.worker_id}
							render={(w: EventWorker)=>(
								<div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
									<Icon name='user' />
									<div style={{ flex: 1 }}>
										<div style={{ fontSize: 14, fontWeight: 'bold' }}>{w.worker_name}</div>
										<div style={{ fontSize: 12, color: 'gray' }}>{w.title_name}</div>
									</div>
								</div>
							)}
						/>
						<Message type='error' list={modalPrompts} />
					</Modal.Content>
					<Modal.Actions>
						<Button text='Cerrar' basic onClick={props.onClose} />
						<Button
							text={`Enviar`}
							color='black'
							onClick={submit}
							disabled={selectedWorkers.length === 0}
						/>
					</Modal.Actions>
				</>
			)}
		</Modal>
	);
};

export default SendConfirmationModal;
